"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TwoToneDomain;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _plus = _interopRequireDefault(require("@ux/icon/plus"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function TwoToneDomain(params) {
  const {
    names = [],
    extensions = [],
    extensionColorClassName = 'text-primary',
    textClassName = '',
    isDesktop = false,
    isMobile = true,
    tagIcon,
    customColor,
    className = ''
  } = params;
  const isAnyDomainLongerThan25Chars = names.some(name => name.length > 25);
  const areAllDomainsLongerThan25Chars = names.reduce((length, name) => {
    length += name.length;
    return length;
  }, 0) > 25;
  const multiLinedomainList = names?.map((name, index) => {
    const tld = extensions[index];
    return /*#__PURE__*/_react.default.createElement("li", {
      key: name + tld,
      className: (0, _classnames.default)(`mb-n1`, {
        'mt-n1': index !== 0
      })
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "d-inline-block"
    }, name, tld && /*#__PURE__*/_react.default.createElement("span", {
      className: "d-inline-block text-primary",
      "data-cy": "two-tone-domain-multi-tld",
      "data-testid": "two-tone-domain-multi-tld"
    }, `.${tld}`)));
  });
  const multiLineDisplay = /*#__PURE__*/_react.default.createElement("ul", {
    "data-cy": "multi-line-display",
    "data-testid": "multi-line-display",
    className: (0, _classnames.default)('list-unstyled font-weight-bold my-1 lh-reset', {
      'd-inline-block mr-1': Boolean(tagIcon)
    })
  }, multiLinedomainList);
  const extensionStyle = customColor ? {
    color: customColor
  } : null;
  const singleLineDisplay = /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "single-line-display",
    "data-testid": "single-line-display",
    className: (0, _classnames.default)('lh-reset mt-2', className, {
      'd-inline-block mr-1': Boolean(tagIcon)
    })
  }, names.map((name, index) => {
    const tld = extensions[index];
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: `${name}-${index}`
    }, index === 1 ? /*#__PURE__*/_react.default.createElement("div", {
      className: "mx-1",
      style: {
        display: 'inline-block'
      }
    }, /*#__PURE__*/_react.default.createElement(_plus.default, {
      height: 16,
      width: 16,
      color: "black"
    })) : null, name === names[index - 1] ? null : name, tld && /*#__PURE__*/_react.default.createElement("span", {
      "data-cy": "two-tone-domain-single",
      "data-testid": "two-tone-domain-single",
      className: `d-inline-block ${extensionColorClassName}`,
      style: extensionStyle
    }, `.${tld}`));
  }));
  const namesAndExtensions = areAllDomainsLongerThan25Chars || isAnyDomainLongerThan25Chars ? multiLineDisplay : singleLineDisplay;
  const textClassnames = textClassName || (0, _classnames.default)('font-weight-semibold', {
    'mb-1': isDesktop,
    'mb-0': !isDesktop
  });
  return /*#__PURE__*/_react.default.createElement("h2", {
    "data-cy": "two-tone-domain",
    "data-testid": "two-tone-domain",
    dir: "ltr",
    className: (0, _classnames.default)('d-inline-block break-text-anywhere', textClassnames, {
      'two-tone-domain': isMobile
    })
  }, namesAndExtensions, tagIcon);
}
TwoToneDomain.propTypes = {
  textClassName: _propTypes.default.string,
  names: _propTypes.default.array.isRequired,
  extensions: _propTypes.default.array.isRequired,
  extensionColorClassName: _propTypes.default.string,
  fontSizeClassName: _propTypes.default.string,
  isDesktop: _propTypes.default.bool,
  isMobile: _propTypes.default.bool,
  tagIcon: _propTypes.default.node,
  customColor: _propTypes.default.string,
  className: _propTypes.default.string
};